import api, { handleResponse, handleError } from './api';

const brandService = {
  async list() {
    try {
      const response = await api.get('/brands');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async create({ name, slug, promoLink, defaultPromoCode, defaultMessage }) {
    try {
      const response = await api.post('/brands', { name, slug, promoLink, defaultPromoCode, defaultMessage });
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async update(id, payload) {
    try {
      const response = await api.put(`/brands/${id}`, payload);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async remove(id) {
    try {
      const response = await api.delete(`/brands/${id}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async uploadLogo(id, file) {
    try {
      const form = new FormData();
      form.append('file', file);
      const response = await api.post(`/brands/${id}/logo`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default brandService;
